// @flow
import React, { Component } from 'react';

import Radio from 'common/domain/radio';

import DateRange from 'common/domain/DateRange';
import SalesPrinting from 'common/modules/sales/components/printing/SalesPrinting';
import Estimation from 'common/modules/proposition/domain/estimation';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

type State = {
  loaded: boolean;
  estimation: ?Estimation;
  radio: ?Radio;
  dateRange: ?DateRange;
}

class SalesPrintingPage extends Component<void, State> {
  state = {
    loaded: false,
    estimation: undefined,
    radio: undefined,
    dateRange: undefined,
  };

  componentWillMount() {
    const data = PrintingService.getData('SALES_DATA');
    if (!data) {
      return;
    }

    this.setState({
      loaded: true,
      estimation: Estimation.parse(data.estimation),
      radio: data.radio,
      dateRange: DateRange.fromISO(data.dateRange),
    }, () => {
      setTimeout(() => window.print(), 1000);
    });
  }

  render() {
    const { loaded, radio, estimation, dateRange } = this.state;
    return (
      <PrintingPage loading={!loaded} >
        {radio && estimation && dateRange &&
          <SalesPrinting
            dateRange={dateRange}
            estimation={estimation}
            radio={radio}
          />
        }
      </PrintingPage>
    );
  }
}

export default SalesPrintingPage;



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/SalesPrintingPage.js